<template>
  <HeaderContent title="Extra Charge Category" />
  <ActionContent
    ctaText="Add Extra Charge Category"
    @action="showModal"
    :filterDate="false"
    :filterModal="false"
    @search-query="searchData"
  />
  <ExtraChargeCategoryStatistics
    title="Extra Charge Category Statistics"
    :data="statistics"
  />
  <ExtraChargeCategoryForm
    :modal="modal"
    :extrachargeCategoryData="extrachargeCategory"
    @update:modal="updateModal"
    @addOrUpdate="getAll"
  />
  <ExtraChargeCategoryConfirm
    title="Confirmation"
    :uuid="extrachargeCategoryUuid"
    v-model="modalConfirm"
    @confirmed="deleteData(extrachargeCategoryUuid)"
  >
    <template #text>Are you sure to delete this data ?</template>
  </ExtraChargeCategoryConfirm>
  <ExtraChargeCategoryDataTable
    :data="extrachargeCategories"
    :header="headers"
    :currentPage="currentPage"
    :custom-actions="customActions"
  />
</template>

<script>
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import ExtraChargeCategoryForm from "./ExtraChargeCategoryForm.vue";
import ExtraChargeCategoryDataTable from "@/components/DataTable.vue";
import ExtraChargeCategoryStatistics from "@/components/StatisticData.vue";
import ExtraChargeCategoryConfirm from "@/components/ModalDialog.vue";
import iconCategoryAlt from "../../../public/icons/category-alt.svg";
import { ref, inject, onMounted } from "vue";

export default {
  components: {
    HeaderContent,
    ActionContent,
    ExtraChargeCategoryForm,
    ExtraChargeCategoryDataTable,
    ExtraChargeCategoryStatistics,
    ExtraChargeCategoryConfirm,
  },
  setup() {
    const repositories = inject("repositories");
    const extrachargeCategoryRepository = repositories
      ? repositories.extraChargeCategory
      : null;
    const modal = ref(false);
    const modalConfirm = ref(false);
    const extrachargeCategoryUuid = ref(null);
    const extrachargeCategory = ref({});
    const extrachargeCategories = ref([]);

    const headers = ref([
      {
        key: "no",
        label: "No",
        class: "text-left",
      },
      {
        key: "name",
        label: "Name",
        sortable: true,
        class: "text-left",
      },
      {
        key: "action",
        label: "Actions",
      },
    ]);

    const customActions = ref([
      {
        label: "Edit",
        variant: "success",
        icon: "fas fa-edit",
        action: (item) => {
          getById(item.uuid);
        },
      },
      {
        label: "Delete",
        variant: "danger",
        icon: "fas fa-trash",
        action: (item) => {
          showConfirmModal(item.uuid);
        },
      },
    ]);

    const statistics = ref([]);

    const getAll = async () => {
      await extrachargeCategoryRepository
        .getAll()
        .then((res) => {
          extrachargeCategories.value = res.data.data;
          statistics.value = [
            {
              label: "Total",
              key: "Extra Charge Category",
              value: res.data.data.length,
              color: "primary",
              icon: iconCategoryAlt,
            },
          ];
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const getById = async (uuid) => {
      await extrachargeCategoryRepository
        .getById(uuid)
        .then((res) => {
          extrachargeCategory.value = res.data.data;
          modal.value = true;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const updateModal = (newValue) => {
      modal.value = newValue;
      extrachargeCategory.value = {};
    };

    const showModal = () => {
      modal.value = true;
    };

    const showConfirmModal = (uuid) => {
      modalConfirm.value = true;
      extrachargeCategoryUuid.value = uuid;
    };

    const deleteData = async (uuid) => {
      await extrachargeCategoryRepository
        .delete(uuid)
        .then(() => {
          modalConfirm.value = false;
          getAll();
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const searchData = async (keyword) => {
      await extrachargeCategoryRepository
        .search(keyword)
        .then((res) => {
          extrachargeCategories.value = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    onMounted(() => {
      getAll();
    });

    return {
      modal,
      modalConfirm,
      extrachargeCategoryUuid,
      extrachargeCategory,
      extrachargeCategories,
      headers,
      customActions,
      statistics,
      updateModal,
      showModal,
      showConfirmModal,
      deleteData,
      getAll,
      getById,
      searchData,
    };
  },
};
</script>
